import { Directive, TemplateRef, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[treeview-template]",
})
export class TreeViewTemplateDirective {
  constructor(
    public templateRef: TemplateRef<any>
  ) {}
}
